import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import noDataToDisplay from "highcharts/modules/no-data-to-display";

const customGapSize = (H) => {
    H.addEvent(H.Series, "afterProcessData", function() {
        if (this.basePointRange <= 3540000) {
            this.options.gapSize = 3540000;
        } else {
            this.options.gapSize = this.basePointRange;
        }
    });
};

if (typeof Highcharts === "object") {
    customGapSize(Highcharts);
    noDataToDisplay(Highcharts);
}

const Charts = ({ options, menuIsOpen, t }) => {
    const chart = useRef(null);
    //noDataToDisplay(Highcharts);
    const numForm = Intl.NumberFormat(undefined, { useGrouping: true });
    const decimalPoint = numForm.formatToParts && numForm.formatToParts(1.2).find(p => p.type === "decimal")?.value || ".";

    useEffect(() => {
        if (chart?.current?.chart !== null) {
            setTimeout(() => {
                chart?.current?.chart?.reflow?.();
            }, 500);
        }
    }, [menuIsOpen]);

    useEffect(() => {
        if (options.series.length === 0) {
            chart.current?.chart?.hideNoData();
            chart.current?.chart?.showNoData(t("forms.graphNoData"));
        }
    }, [t]);

    Highcharts.setOptions({
        lang: {
            resetZoom: t("forms.graphResetZoom"),
            loading: t("forms.graphCargando"),
            months: t("forms.graphMeses").split("-"),
            weekdays: t("forms.graphDays").split("-"),
            shortMonths: t("forms.graphMeses").split("-"),
            shortWeekdays: t("forms.graphDays").split("-"),
            decimalPoint
        }
    });

    return (
        <HighchartsReact highcharts={Highcharts} constructorType="stockChart" options={options} ref={chart} />
    );
};

export default Charts;
